// =============================================================================
// SIREPPAR - Referencia a la observación o intimación de una consulta (#389)
// =============================================================================
// Recuadro de solo lectura con la observación o intimación desde la que se
// inició una consulta, y el aviso fijo de que el plazo sigue corriendo. Lo usan
// la pantalla de nueva consulta y el detalle de la consulta del partido.
// Si la intimación está vigente lo decide el backend; acá solo se muestra.
// =============================================================================

import { Link } from 'react-router-dom';
import TextoColapsable from './TextoColapsable';
import { formatearFecha } from '../../utils/consultas';

export const TEXTO_PLAZO_INTIMACION =
  'El plazo de la intimación sigue corriendo. Esta consulta no reemplaza la respuesta, que debe presentarse desde el expediente.';

export interface ObservacionReferencia {
  id: string;
  tipo: string;
  creadoEn: string;
  fechaLimite: string | null;
  texto: string;
}

export const etiquetaTipoObservacion = (tipo: string) => (tipo === 'INTIMACION' ? 'Intimación' : 'Observación');

/** Línea fija sobre los plazos. Solo se muestra con una intimación vigente. */
export function AvisoPlazoIntimacion() {
  return (
    <p className="rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-sm font-medium text-amber-900">
      {TEXTO_PLAZO_INTIMACION}
    </p>
  );
}

export default function ReferenciaObservacionConsulta({
  observacion,
  expediente,
  conLink = false,
}: {
  observacion: ObservacionReferencia;
  expediente: { id: string; numero: string };
  /** En el detalle se ofrece volver a la pestaña de observaciones del expediente. */
  conLink?: boolean;
}) {
  return (
    <div className="rounded-lg border border-gray-200 bg-gray-50 p-4 text-sm">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-1">
        <span className="font-semibold text-gray-800">
          {etiquetaTipoObservacion(observacion.tipo)} del expediente {expediente.numero}
        </span>
        {conLink && (
          <Link to={`/expedientes/${expediente.id}?tab=obs`} className="text-blue-600 hover:underline">
            Ver en el expediente →
          </Link>
        )}
      </div>
      <p className="text-xs text-gray-600 mb-2">
        Fecha: {formatearFecha(observacion.creadoEn)} · Fecha límite: {formatearFecha(observacion.fechaLimite)}
      </p>
      <TextoColapsable texto={observacion.texto} tope={300} className="text-gray-700" />
    </div>
  );
}
